const slide = document.querySelectorAll("[data-slide]");

if (slide) {
    slide.forEach((e) => {
        let button;
        let block;
        const dataSlideValue = e.getAttribute("data-slide");

        if (dataSlideValue) {
          button = e.querySelector(`[data-slide-button="${dataSlideValue}"]`);
          block = e.querySelector(`[data-slide-block="${dataSlideValue}"]`);
        } else {
          button = e.querySelector("[data-slide-button]");
          block = e.querySelector("[data-slide-block]");
        }

          !!button &&
            button.addEventListener("click", () => {
              if (button.dataset.more !== undefined) {
                if (button.classList.contains("active")) {
                  button.innerHTML = button.dataset.more;
                } else {
                  button.innerHTML = button.dataset.less;
                }
              }

              button.classList.toggle("active");
              !!block && slideToggle(block);
            });
    });
}

function slideToggle(e, time = 300) {
    if (getComputedStyle(e).visibility == "hidden") {
        slideShow(e, time);
    } else {
        slideHide(e, time);
    }
}

function slideShow(e, time = 300) {
    if (getComputedStyle(e).visibility == "hidden") {
        e.style.overflow = "hidden";
        delete e.dataset.slideBlock;

        const h = +getComputedStyle(e).height.replace("px", "");

        setCss(e, "0px", "0px", "0px", "0px", "0px", "0px", "0px");

        setTimeout(() => {
            e.style.transition = time + "ms";
            setCss(e, h + "px");
        }, 0);

        setTimeout(() => {
            setCss(e);
            e.style.overflow = "";
            e.style.transition = "";
            e.classList.add("active");
        }, time);
    }
}

function slideHide(e, time = 300) {
    if (getComputedStyle(e).visibility != "hidden") {
        e.style.overflow = "hidden";
        const h = +getComputedStyle(e).height.replace("px", "");

        e.style.height = h + "px";

        setTimeout(() => {
            e.style.transition = time + "ms";
            setCss(e, "0px", "0px", "0px", "0px", "0px", "0px", "0px");
        }, 0);

        setTimeout(() => {
            e.dataset.slideBlock = "";
            setCss(e);
            e.style.overflow = "";
            e.style.transition = "";
            e.classList.remove("active");
        }, time);
    }
}

function setCss(
    e,
    h = "",
    pT = "",
    pB = "",
    mT = "",
    mB = "",
    bT = "",
    bB = ""
) {
    e.style.height = h;
    e.style.paddingTop = pT;
    e.style.paddingBottom = pB;
    e.style.marginTop = mT;
    e.style.marginBottom = mB;
    e.style.borderTopWidth = bT;
    e.style.borderBottomWidth = bB;
}
